import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_ASSISTANT_TODAY_REPORT, SEND_EMAIL } from "@repo-sapiens/graphql";
import { SendEmailDto } from "@repo-sapiens/types";
import { useCallback, useEffect } from "react";

export const useCapability = () => {
  const [getReport] = useLazyQuery(GET_ASSISTANT_TODAY_REPORT, {
    fetchPolicy: 'cache-first',
  });

  const [sendEmailForUser] = useMutation<{ sendEmail: string}, {data: SendEmailDto }>(SEND_EMAIL);
  
  useEffect(() => {
    getReport();
  }, [getReport]);
  
  const getUserReport =  useCallback(async (args?: Record<string, unknown>) => {
    const { data } = await getReport();
    const assistantReport = JSON.parse(data?.getAssistantTodayReport || '{}');
    return {
      result: 'success',
      data: assistantReport
    }
  }, [getReport]);

  const sendEmail =  useCallback(async (args?: Record<string, unknown>) => {
    const { data } = await sendEmailForUser({
      variables: {
        data: {
          to: args?.to as string[],
          subject: args?.subject as string,
          body: args?.body as string,
          cc: args?.cc as string[],
          bcc: args?.bcc as string[],
        },
      },
    });
    return {
      result: 'success',
      data: {
        email_sent: true,
        email_id: data?.sendEmail,
      }
    };
  }, [sendEmailForUser]);

  const checkAvailability =  useCallback(async (args?: Record<string, unknown>) => {
    return {
      result: 'success',
      data: {
        availability: 'No availability for that time',
      }
    };
  }, []);

  return {
    getUserReport,
    sendEmail,
    checkAvailability,
  };
};